import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DEFAULT_PERIOD_MONTHS, PERIOD_STORE_KEY } from './constants';

interface PeriodStore {
  /** The globally selected (requested) licensing period in months. */
  requestedPeriodMonths: number;
  setRequestedPeriodMonths: (months: number) => void;
}

export const usePeriodStore = create<PeriodStore>()(
  persist(
    (set) => ({
      requestedPeriodMonths: DEFAULT_PERIOD_MONTHS,
      setRequestedPeriodMonths: (months) => set({ requestedPeriodMonths: months }),
    }),
    { name: PERIOD_STORE_KEY },
  ),
);
